import React from "react";
import { Stack } from "@chakra-ui/react";
import { PatientDocumentComponent } from "../components/patient-document.component";

import { useSearchParams } from "react-router-dom";

interface Props {}

export const PatientDocumentPage: React.FC<Props> = (props: Props) => {
  let [searchParams, setSearchParams] = useSearchParams();

  const policeCaseId = searchParams.get("caseId");
  const subjectIndex = parseInt(
    searchParams.get("subjectIndex")
      ? (searchParams.get("subjectIndex") as string)
      : "0"
  );

  return (
    <Stack>
      <PatientDocumentComponent
        policeCaseId={policeCaseId as string}
        subjectIndex={subjectIndex}
      />
    </Stack>
  );
};
